import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  showPassword: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    apiError(state, action) {
      // Handle error payload - can be a string or object
      if (typeof action.payload === 'string') {
        state.error = action.payload;
      } else if (action.payload?.message) {
        state.error = action.payload.message;
      } else if (action.payload?.error) {
        state.error = action.payload.error;
      } else {
        state.error = "An error occurred during login";
      }
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload
      state.loading = false;
      state.errorMsg = false;
      state.error = "";
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true
    },
    reset_login_flag(state) {
      state.error = null
      state.loading = false;
      state.errorMsg = false;
    }
  },
});

export const {
  setLoading,
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;